<template>
  <!-- 附加服务弹出层 -->

  <van-popup z-index="1000" v-model:show="showBottom" id="additionalservices" @close="close" position="bottom">
    <div class="main">
      <!-- 标题 -->
      <div class="top-box">
        <h2>{{ $fanyi('附加服务') }}</h2>
        <van-icon @click="showBottom = false" name="cross" />
      </div>

      <div class="optionlist">
        <div class="item" v-for="item in optionlist" :key="item.id">
          <div class="title">
            <input class="checkbox-box" @change="checkboxchange(item)" type="checkbox" v-model="item.checked" />
            <span>{{ item.name_translate }}</span>
          </div>
          <div class="content">
            <div class="num">
              <van-stepper @change="changeinput(item)" :min="1" integer v-model="item.num" />
            </div>
            <div class="unitprice">
              <p class="text">{{ $fanyi('单价') }}</p>
              <p class="price">${{
                $fun.EURNumSegmentation(
                  $fun.ceil(item.price * $store.state.exchangeRate)
                )
              }} (￥{{ $fun.RMBNumSegmentation(item.price) }})
              </p>
            </div>
            <div class="subtotal">
              <p class="text">{{ $fanyi('小计') }}</p>
              <p class="price">${{
                $fun.EURNumSegmentation(
                  $fun.ceil((item.price * item.num) * $store.state.exchangeRate)
                )
              }} (￥{{ $fun.RMBNumSegmentation(item.price * item.num) }})
              </p>
            </div>
          </div>

        </div>
      </div>

    </div>
  </van-popup>
</template>
<script setup>
import { getCurrentInstance, ref, defineExpose } from 'vue'
const { proxy } = getCurrentInstance()
const showBottom = ref(false)
const optionlist = ref([])// option 列表
const goodsnum = ref(1) // 商品数量
const goodsitem = ref({})// 单个商品数据数据
console.log(proxy);
const open = (item, goods) => {
  optionlist.value = item
  goodsnum.value = goods.num
  goodsitem.value = goods
  showBottom.value = true
}
const changeinput = () => {

}
const checkboxchange = (item) => {

  if (item.name !== '摄影' && item.checked == true) {
    item.num = goodsnum.value
  }
}
// 关闭弹层时触发
const close = () => {

  if (optionlist.value.every((ite) => ite.checked == false)) {
    goodsitem.value.option = []

  } else {
    goodsitem.value.option = optionlist.value
  }


  // console.log(goodsitem.value);

}
defineExpose({
  open
})
</script>
<style lang="scss">
#additionalservices {
  min-height: 60%;

  max-height: 88%;

  background: #FFFFFF;
  border-radius: 8px 8px 0px 0px;



  .top-box {
    position: sticky;
    top: 0px;
    z-index: 2000;
    width: 100%;
    height: 44px;
    background: #F6F6F6;
    border-radius: 8px 8px 0px 0px;

    display: flex;
    justify-content: center;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 24px;
    align-items: center;

    .van-icon-cross {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 20px;
      color: #222222;
      font-weight: 600;
      font-size: 16px;

      // top: 14px;

    }
  }

}
</style>
<style lang='scss' scoped='scoped'>
@import "@/style/scss/mixin.scss";

// 选择框样式
.checkbox-box {


  width: 12px;
  height: 12px;
  padding: 0px;
  margin: 0px;
  border-radius: 2px;
  border: 1px solid #dedede;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin-right: 5px;

  border: 1px solid #ccc;
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  position: relative;
}

input[type="checkbox"]:checked {
  background: #ff730b;
  border-color: #ff730b;
  border: 1px solid#ff730b;
}

input[type="checkbox"]::before {
  position: absolute;
  top: -2px;
  left: -1px;
  content: "\2713";
  /* Unicode编码，表示对号 */
  display: inline-block;

  width: 12px;
  height: 12px;

  text-align: center;
  font-size: 14px;
  opacity: 0;
  color: #ffffff;
  /* 对号的颜色 */
  font-weight: bold;
  transform: scale(0.8, 0.5);
  /* 缩放 */
  transition: transform 0.2s ease-in-out;
  /* 缩放过渡效果 */
}

input[type="checkbox"]:checked::before {
  opacity: 1;
}

.main {
  width: 100%;
  height: 100%;




  .optionlist {
    padding: 10px;

    .item {
      width: 100%;

      min-height: 88px;
      background: #FFFFFF;
      border-radius: 6px;
      border: 0.5px solid #E2E2E2;
      padding: 15px;
      margin-bottom: 10px;

      .title {

        display: flex;
        align-items: center;
        height: 18px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 18px;

        span {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          line-height: 18px;
        }
      }

      .content {
        padding-top: 10px;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .num {
          width: 100px;
          height: 30px;
          border-radius: 4px;
          border: 1px solid #222222;
          display: flex;
          justify-content: center;
          align-items: center;

          :deep().van-haptics-feedback {
            width: 22px;
            height: 22px;
            background: #f2f2f2;
            border-radius: 2px;
          }

          :deep().van-stepper__minus--disabled {
            width: 22px;
            height: 22px;
            background: #f2f2f2;
            border-radius: 2px;
          }

          :deep().van-stepper {
            height: 22px;
            display: flex;
            align-items: center;
          }

          :deep().van-stepper__input {
            width: 40px;
            height: 16px;
            font-size: 12px;

            font-family: ArialMT;
            background-color: #fff;
          }
        }

        .unitprice {
          width: 90px;
          min-height: 30px;

          .text {
            height: 14px;
            font-size: 10px;
            font-family: ArialMT;
            color: #999999;
            line-height: 12px;
          }

          .price {
            font-size: 12px;
            font-family: ArialMT;
            color: #222222;
            line-height: 16px;
          }
        }

        .subtotal {
          width: 90px;
          min-height: 30px;

          .text {
            height: 14px;
            font-size: 10px;
            font-family: ArialMT;
            color: #999999;
            line-height: 12px;
          }

          .price {
            font-size: 12px;
            font-family: ArialMT;
            color: #222222;
            line-height: 16px;
          }
        }

      }
    }

  }

}
</style>